'use strict';
(() => {
  if (window.vorugSwatchRequestReady) return;
  window.vorugSwatchRequestReady = true;
  const draftFields = ['contact[name]', 'contact[Title]', 'contact[email]', 'contact[phone]', 'contact[Reason for swatches]', 'contact[Designer or studio]', 'contact[Project]', 'contact[Project country]'];
  const codeList = value => [...new Set((Array.isArray(value) ? value : []).filter(code => typeof code === 'string' && /^\d{2,3}$/.test(code)))];
  const text = value => typeof value === 'string' ? value.slice(0, 250) : '';

  function init(root) {
    if (root.dataset.vsrfReady) return;
    root.dataset.vsrfReady = 'true';
    const form = root.querySelector('form');
    const owner = root.closest('[data-vorug-color-library]') || root.closest('.shopify-section')?.querySelector('[data-vorug-color-library]');
    const field = name => form.elements.namedItem(name);
    const button = root.querySelector('[data-vsrf-submit]');
    const rail = root.querySelector('[data-vsrf-selection-list]');
    const selection = root.querySelector('[data-vsrf-selection]');
    const selectionHint = root.querySelector('[data-vsrf-selection-hint]');
    const selectionError = root.querySelector('[data-vsrf-selection-error]');
    const changeSelection = root.querySelector('[data-vsrf-change-selection]');
    const clientErrors = root.querySelector('[data-vsrf-client-errors]');
    const errorList = root.querySelector('[data-vsrf-error-list]');
    const serverErrors = root.querySelector('[data-vsrf-server-errors]');
    const success = root.querySelector('[data-vsrf-success]');
    const isResponseTarget = location.hash === '#' + form.id;
    const postedSuccess = !!success && isResponseTarget;
    root.dataset.vsrfState = postedSuccess ? 'success' : 'ready';
    if (success && !isResponseTarget) success.hidden = true;
    if (serverErrors && !isResponseTarget) serverErrors.hidden = true;
    const submitLabel = root.querySelector('[data-vsrf-submit-label]');
    const readyLabel = submitLabel.textContent;
    const name = root.querySelector('[data-vsrf-name]');
    const title = root.querySelector('[data-vsrf-title]');
    const email = root.querySelector('[data-vsrf-email]');
    const phone = root.querySelector('[data-vsrf-phone]');
    const reason = root.querySelector('[data-vsrf-reason]');
    const managedFields = [name, title, email, phone, reason];
    const touched = new WeakSet();
    const projectDetails = root.querySelector('[data-vsrf-project-details]');
    const storageKey = 'vorug:swatch-request-draft:v2:' + root.dataset.sectionId;
    let items = [], bundles = [], invalidQueued = false, returnFocus = null, focusLibrary = false, sending = false;

    function normalise(detail) {
      const seen = new Set();
      items = (Array.isArray(detail?.items) ? detail.items : []).filter(item => {
        if (item?.type !== 'pom' || typeof item.code !== 'string' || !/^\d{2,3}$/.test(item.code) || seen.has(item.code)) return false;
        seen.add(item.code);
        return true;
      }).slice(0, 62).map(item => ({type: 'pom', code: item.code, name: text(item.name), pantoneName: text(item.pantoneName || item.pantone_name), pantoneCode: text(item.pantoneCode || item.pantone_code), image: typeof item.image === 'string' ? item.image.slice(0, 2048) : ''}));
      bundles = (Array.isArray(detail?.bundleSelections) ? detail.bundleSelections : []).filter(bundle => bundle && ['full', 'partial'].includes(bundle.state)).slice(0, 20).map(bundle => ({id: text(bundle.id), name: text(bundle.name), state: bundle.state, pomCodes: codeList(bundle.pomCodes), selectedPomCodes: codeList(bundle.selectedPomCodes).filter(code => seen.has(code))})).filter(bundle => bundle.selectedPomCodes.length);
    }

    const pomLine = item => item.code + ' · ' + item.name + (item.pantoneCode ? ' — ' + root.dataset.approxLabel + ': ' + [item.pantoneName, item.pantoneCode].filter(Boolean).join(' · ') : '');
    const bundleLine = bundle => bundle.name + ' [' + bundle.id + '] — ' + (bundle.state === 'full' ? root.dataset.bundleFull : root.dataset.bundlePartial) + ': ' + bundle.selectedPomCodes.join(', ');

    function syncBody() {
      const poms = items.map(pomLine).join('\n');
      const coverage = bundles.map(bundleLine).join('\n');
      root.querySelector('[data-vsrf-selected-input]').value = poms;
      root.querySelector('[data-vsrf-bundles-input]').value = coverage;
      const message = [root.dataset.messageIntro, root.dataset.pomsLabel + ':\n' + poms];
      if (coverage) message.push(root.dataset.bundlesLabel + ':\n' + coverage);
      for (const key of draftFields) {
        const input = field(key);
        if (!input?.value.trim()) continue;
        const label = form.querySelector('label[for="' + input.id + '"]')?.textContent.replace('*', '').trim() || key;
        message.push(label + ': ' + input.value.trim());
      }
      root.querySelector('[data-vsrf-body]').value = message.join('\n\n');
    }

    function saveDraft() {
      if (success && isResponseTarget) return;
      const values = Object.fromEntries(draftFields.map(key => [key, field(key)?.value || '']));
      const phoneCountry = window.intlTelInput?.getInstance(phone)?.getSelectedCountry()?.iso2 || '';
      try {sessionStorage.setItem(storageKey, JSON.stringify({savedAt: Date.now(), values, phoneCountry, items, bundleSelections: bundles, open: root.open, projectOpen: projectDetails.open}));} catch (_) {}
    }

    function removeIcon() {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'm5 5 10 10M15 5 5 15');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.25');
      svg.append(path);
      return svg;
    }

    function renderSelection(detail) {
      normalise(detail);
      const previousScroll = rail.scrollLeft;
      rail.replaceChildren(...items.map(item => {
        const li = document.createElement('li');
        li.className = 'vsrf-rail-item';
        const thumb = document.createElement('div');
        thumb.className = 'vsrf-thumb';
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 96;
        img.height = 96;
        img.decoding = 'async';
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'vsrf-remove';
        remove.dataset.vsrfRemoveCode = item.code;
        remove.setAttribute('aria-label', root.dataset.removeLabel.replace('__name__', item.name).replace('__code__', item.code));
        remove.append(removeIcon());
        thumb.append(img, remove);
        const caption = document.createElement('p');
        caption.className = 'vsrf-pom-label';
        const label = document.createElement('span');
        label.className = 'vsrf-pom-name';
        label.textContent = item.name;
        const code = document.createElement('span');
        code.className = 'vsrf-pom-code';
        code.textContent = item.code;
        caption.append(label, code);
        li.append(thumb, caption);
        return li;
      }));
      rail.scrollLeft = previousScroll;
      rail.hidden = items.length === 0;
      const count = root.querySelector('[data-vsrf-selection-count]');
      count.textContent = items.length ? (items.length === 1 ? root.dataset.selectionOne : root.dataset.selectionMany.replace('__count__', String(items.length))) : root.dataset.selectionEmpty;
      selectionHint.hidden = items.length > 0;
      changeSelection.hidden = items.length > 0;
      button.disabled = items.length === 0 || postedSuccess || sending;
      if (items.length) selectionError.hidden = true;
      syncBody();
      saveDraft();
    }

    function openRequest(focusTarget) {
      if (!root.open) {
        returnFocus = document.activeElement;
        root.showModal();
        document.body.classList.add('vsrf-drawer-open');
      }
      const target = focusTarget || root.querySelector('[data-vsrf-title-heading]');
      requestAnimationFrame(() => {
        target.focus({preventScroll: true});
        if (focusTarget) target.scrollIntoView({block: 'nearest', behavior: 'auto'});
      });
      saveDraft();
    }

    function closeRequest() {
      if (root.open) root.close();
    }

    function fieldMessage(input) {
      if (!input.value.trim()) {
        if (input === name) return root.dataset.nameRequired;
        if (input === title) return root.dataset.titleRequired;
        if (input === email) return root.dataset.emailRequired;
        if (input === reason) return root.dataset.reasonRequired;
      }
      if (input === email && input.validity.typeMismatch) return root.dataset.emailInvalid;
      if (input === phone && input.validationMessage) return typeof phone.vorugValidatePhone === 'function' ? root.querySelector('[data-phone-error]').textContent || input.validationMessage : input.validationMessage;
      return input.validationMessage;
    }

    function refreshValidity(input) {
      if (input === phone && typeof phone.vorugValidatePhone === 'function') {
        phone.vorugValidatePhone();
        return;
      }
      input.setCustomValidity('');
      if (input.required && input.value && !input.value.trim()) input.setCustomValidity(fieldMessage(input));
      if (input === phone && input.value.trim()) {
        const value = input.value.trim().replace(/[\s().-]/g, '');
        if (!/^\+[1-9]\d{6,14}$/.test(value)) input.setCustomValidity(root.dataset.phoneInvalid);
      }
    }

    function showFieldError(input) {
      refreshValidity(input);
      const invalid = !input.validity.valid;
      const inline = [...root.querySelectorAll('[data-vsrf-field-error]')].find(note => note.dataset.vsrfFieldError === input.name);
      const message = invalid ? fieldMessage(input) : '';
      if (invalid) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      inline.textContent = message;
      inline.hidden = !invalid;
      return message;
    }

    function showErrors(selectionMissing = false) {
      const errors = [];
      for (const input of managedFields) {
        touched.add(input);
        const message = showFieldError(input);
        if (message) errors.push({target: input.id, message});
      }
      selectionError.hidden = !selectionMissing;
      if (selectionMissing) {
        selectionError.textContent = root.dataset.selectionRequired;
        errors.push({target: selection.id, message: root.dataset.selectionRequired});
      }
      errorList.replaceChildren(...errors.map(error => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + error.target;
        link.textContent = error.message;
        li.append(link);
        return li;
      }));
      clientErrors.hidden = errors.length === 0;
      if (errors.length) openRequest(clientErrors);
    }

    let restoreOpen = false, restoredPhoneCountry = '';
    try {
      const draft = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (draft && Date.now() - draft.savedAt < 8 * 60 * 60 * 1000) {
        for (const key of draftFields) {
          const input = field(key);
          if (input && !input.value && typeof draft.values?.[key] === 'string') input.value = draft.values[key].slice(0, input.maxLength > 0 ? input.maxLength : 2000);
        }
        restoredPhoneCountry = typeof draft.phoneCountry === 'string' ? draft.phoneCountry : '';
        restoreOpen = draft.open === true;
        projectDetails.open = draft.projectOpen === true;
        normalise(draft);
      }
    } catch (_) {}

    const initial = owner?.vorugSwatchSelection?.getDetail();
    if (initial) renderSelection(initial);
    else renderSelection({items: items.map(item => ({...item, type: 'pom'})), bundleSelections: bundles});
    managedFields.filter(input => input !== phone).forEach(refreshValidity);
    const phoneInstance = window.intlTelInput?.getInstance(phone);
    if (phoneInstance) {
      if (/^[a-z]{2}$/i.test(restoredPhoneCountry)) phoneInstance.setSelectedCountry(restoredPhoneCountry);
      if (phone.value.trim()) phoneInstance.setNumber(phone.value);
    } else {
      const hint = root.querySelector('.vsrf-phone-hint');
      if (hint) hint.textContent = root.dataset.phoneFallback;
    }
    phone.vorugPhoneReady?.then(() => {
      if (!root.isConnected) return;
      if (touched.has(phone)) showFieldError(phone);
      syncBody();
    });
    const onSelection = event => {
      if (String(event.detail?.sectionId) !== root.dataset.sectionId) return;
      renderSelection(event.detail);
      if (event.type === 'vorug:swatch-request') openRequest();
    };
    document.addEventListener('vorug:swatch-selection-change', onSelection);
    document.addEventListener('vorug:swatch-request', onSelection);
    root.querySelector('[data-vsrf-close]').addEventListener('click', closeRequest);
    root.addEventListener('cancel', event => {event.preventDefault(); closeRequest();});
    root.addEventListener('close', () => {
      document.body.classList.remove('vsrf-drawer-open');
      saveDraft();
      const libraryHeading = owner?.querySelector('[id$="-poms-title"]');
      const target = !focusLibrary && returnFocus?.isConnected && returnFocus.getClientRects().length ? returnFocus : libraryHeading;
      const scrollToLibrary = focusLibrary;
      focusLibrary = false;
      if (target === libraryHeading && target) target.tabIndex = -1;
      if (target?.isConnected) requestAnimationFrame(() => {
        target.focus({preventScroll: true});
        if (scrollToLibrary) target.scrollIntoView({block: 'center', behavior: 'auto'});
      });
    });
    root.addEventListener('click', event => {
      if (event.target !== root) return;
      const rect = root.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeRequest();
    });
    changeSelection.addEventListener('click', () => {focusLibrary = true; closeRequest();});
    projectDetails.addEventListener('toggle', saveDraft);
    rail.addEventListener('click', event => {
      const remove = event.target.closest('[data-vsrf-remove-code]');
      if (!remove || !rail.contains(remove)) return;
      const code = remove.dataset.vsrfRemoveCode;
      const index = items.findIndex(item => item.code === code);
      const removedName = items[index]?.name;
      if (index < 0 || !owner?.vorugSwatchSelection?.remove(code)) return;
      root.querySelector('[data-vsrf-rail-status]').textContent = root.dataset.removedLabel.replace('__name__', removedName);
      const next = rail.querySelectorAll('[data-vsrf-remove-code]')[Math.min(index, items.length - 1)] || selection;
      requestAnimationFrame(() => next.focus({preventScroll: true}));
    });
    function onFieldEnter(event) {
      const input = event.target;
      if (event.key !== 'Enter' || event.defaultPrevented || event.isComposing || event.keyCode === 229 || input?.tagName !== 'INPUT' || !draftFields.includes(input.name)) return;
      event.preventDefault();
      refreshValidity(input);
      if (!input.validity.valid) {
        touched.add(input);
        showFieldError(input);
        return;
      }
      const visibleFields = draftFields.map(field).filter(control => control && !control.disabled && control.getClientRects().length);
      const next = visibleFields[visibleFields.indexOf(input) + 1] || (!button.disabled ? button : selection);
      next.focus();
      if (next !== button) next.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'auto'});
    }
    form.addEventListener('keydown', onFieldEnter);
    form.addEventListener('focusin', event => {
      if (managedFields.includes(event.target)) touched.add(event.target);
    });
    form.addEventListener('focusout', event => {
      if (managedFields.includes(event.target) && touched.has(event.target)) showFieldError(event.target);
    });
    form.addEventListener('input', event => {
      if (managedFields.includes(event.target)) {
        if (event.target !== phone) {
          refreshValidity(event.target);
          if (event.target.validity.valid || event.target.hasAttribute('aria-invalid')) showFieldError(event.target);
        }
        clientErrors.hidden = true;
      }
      syncBody();
      saveDraft();
    });
    form.addEventListener('change', event => {
      if (event.target === title && touched.has(title)) showFieldError(title);
      syncBody();
      saveDraft();
    });
    phone.addEventListener('countrychange', () => {syncBody(); saveDraft();});
    form.addEventListener('invalid', event => {
      if (!managedFields.includes(event.target)) return;
      event.preventDefault();
      if (invalidQueued) return;
      invalidQueued = true;
      queueMicrotask(() => {invalidQueued = false; showErrors(items.length === 0);});
    }, true);
    form.addEventListener('submit', event => {
      if (event.defaultPrevented) return;
      if (sending) {event.preventDefault(); return;}
      const current = owner?.vorugSwatchSelection?.getDetail();
      if (current) renderSelection(current);
      managedFields.forEach(refreshValidity);
      syncBody();
      saveDraft();
      if (postedSuccess || !items.length || managedFields.some(input => !input.validity.valid)) {
        event.preventDefault();
        showErrors(!items.length);
        return;
      }
      sending = true;
      queueMicrotask(() => {
        if (event.defaultPrevented) {resetSending(); return;}
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        form.setAttribute('aria-busy', 'true');
        submitLabel.textContent = root.dataset.sendingLabel;
      });
    });
    const resetSending = () => {
      sending = false;
      button.disabled = items.length === 0 || postedSuccess || sending;
      button.removeAttribute('aria-busy');
      form.removeAttribute('aria-busy');
      submitLabel.textContent = readyLabel;
    };
    const onPageShow = resetSending;
    window.addEventListener('pageshow', onPageShow);
    if (isResponseTarget && success) {
      try {sessionStorage.removeItem(storageKey);} catch (_) {}
      openRequest(success);
    } else if (isResponseTarget && serverErrors) openRequest(serverErrors);
    else if (restoreOpen || isResponseTarget) openRequest();
    const onUnload = event => {
      if (!event.target.contains(root)) return;
      closeRequest();
      document.removeEventListener('vorug:swatch-selection-change', onSelection);
      document.removeEventListener('vorug:swatch-request', onSelection);
      window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('shopify:section:unload', onUnload);
  }
  document.querySelectorAll('[data-vorug-swatch-request-form]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vorug-swatch-request-form]').forEach(init));
})();
